import { atom } from 'jotai';

/** 약관 분류(termCategoryId)별로 선택한 약관 id. TermSelectBottomSheet 에서 선택한 값을 상세 화면으로 전달한다. */
export const termIdsAtom = atom<Record<string, string>>({});
